import { GridRowSelectionModel } from "@mui/x-data-grid-pro";

type Row = {
    id: number;
};

export const handleRowSelection = (
    rowSelectionModel: GridRowSelectionModel,
    rows: Row[]
): number[] => {
    // All rows selected, set their ids
    if (rowSelectionModel.type === "exclude") {
        // handle exclusions
        const selectedIds = rows
            .filter((row) => !rowSelectionModel.ids.has(row.id))
            .map((row) => row.id);

        return selectedIds;
    } else {
        // handle inclusions
        const selectedIds = Array.from(rowSelectionModel.ids) as number[];

        return selectedIds;
    }
};
